import React, { Component } from 'react';
import Slider from "react-slick";
import { testimonialsData } from '../../utils/constants';
import FrontBanner from "@/assets/images/front-banner.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './testimonials.scss';

export default class Testimonials extends Component {

    settings = {
        dots: false,
        infinite: true, // Enable infinite loop globally
        arrows: false,
        speed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        rows: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        cssEase: "linear",
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1440,
                settings: { slidesToShow: 3, dots: true, rows: 1, infinite: true },
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3, dots: true, rows: 1, infinite: true },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2, dots: true, rows: 1, infinite: true },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1, dots: true, rows: 1, infinite: true },
            },
        ],
    };
    render() {

        return (
            <div className="testimonial-section">
                <h1 className="testimonial-heading">Testimonials</h1>
                <div className="testimonial-slide">
                    <Slider {...this.settings}>
                        {testimonialsData.map((testimonial, index) => {
                            return (
                                <div className="testimonial-card" key={index}>
                                    <div className="testimonial-header">
                                        <img
                                            src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg"
                                            alt="DNY Enterprises"
                                            className="profile-img"
                                        />
                                        <div className="profile-info">
                                            <h3>{testimonial?.name}</h3>
                                            {testimonial?.subLabel && <p>{testimonial?.subLabel}</p>}
                                        </div>
                                    </div>
                                    <div className="testimonial-body">
                                        <p>
                                            {testimonial?.description}
                                        </p>
                                    </div>
                                    {testimonial?.writtenBy && <div className="testimonial-footer">
                                        {testimonial?.writtenBy}
                                    </div>}
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        )
    }
}
